import React, { useState } from 'react';
import Logo_Xira_Color from './assets/Logo_Xira-2.png';
import logo from './assets/LogoCliente.png';

/* Roles
1.- Admin
2.- Reportería y Monitoreo
*/
const Login = ({ user, login }) => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	return (
		<div style={{ width: '80%', margin: '120px auto' }}>
			<div className='form-container'>
				<div style={{ textAlign: 'center', marginTop: '-20px' }}>
					<img src={Logo_Xira_Color} alt='Logo_Xira_Color' className='Logo_Xira_Color' />
					<img src={logo} className='LoginComponent-image' alt='Logo_Izzi' />
				</div>
				<div>
					<h3 className='LoginComponent-header'>PLATAFORMA DE CHATBOTS</h3>
					<hr className='LoginComponent-header-line' />
				</div>

				<div className='LoginComponent-middle-container'>
					<div className='LoginComponent-fields-container'>
						<b>Usuario</b>
						<br />
						<input
							onChange={(e) => setUsername(e.target.value)}
							onKeyPress={(e) => (e.keyCode || e.which) === 13 && login({ username: username, password: password })}
							value={username}
							style={{ width: '60%' }}
						/>
						<br />
						<b>Contraseña</b>
						<br />
						<input
							onChange={(e) => setPassword(e.target.value)}
							onKeyPress={(e) => (e.keyCode || e.which) === 13 && login({ username: username, password: password })}
							value={password}
							style={{ width: '60%' }}
							type='password'
						/>
					</div>
				</div>
				<div className='LoginComponent-buttons' align='right'>
					{user === false && (
						<div style={{ display: 'inline', color: 'red', marginRight: 20 }}>Usuario o Contraseña incorrectos</div>
					)}
					<button
						disabled={username.length === 0 || password.length === 0}
						onClick={() => login({ username: username, password: password })}
						className='form-button primary-button'>
						Iniciar Sesión
					</button>
				</div>
			</div>
		</div>
	);
};

export default Login;
